/*
 * Les titres et descriptions du site, une entrée par page indexable
 * (issue #141).
 *
 * Ils vivent ensemble plutôt que dans chaque page pour deux raisons. La
 * première est éditoriale : ces textes se relisent les uns contre les autres,
 * sinon deux pages finissent par se décrire pareil et les moteurs en écartent
 * une. La seconde est mécanique : un test peut alors vérifier leurs longueurs
 * et leur unicité d'un seul regard.
 *
 * Ils sont dans les contrats, et non dans le site, depuis l'issue #149 : le
 * script qui écrit les métadonnées dans le HTML livré tourne sous Node, et ne
 * sait pas importer un module du site — `src/` n'est compilé que par webpack.
 * Deux copies de ces textes auraient divergé au premier changement.
 */

/**
 * Les fourchettes que Google affiche sans tronquer. Ce ne sont pas des
 * limites techniques : dépasser n'empêche rien, cela fait couper le texte en
 * plein milieu dans les résultats de recherche.
 */
export const LONGUEURS = {
  titre: { min: 50, max: 60 },
  description: { min: 120, max: 160 },
} as const

/**
 * Le titre de la page « introuvable ». Hors du tableau ci-dessous : cette
 * page n'est pas indexable, elle répond 404 (issue #144) et ne déclare aucune
 * canonique. Les fourchettes ne la concernent donc pas.
 */
export const TITRE_INTROUVABLE = 'Page introuvable — Azoya Spa Vaux'

export interface MetadonneesDePage {
  titre: string
  description: string
}

export const metadonneesDesPages: Readonly<Record<string, MetadonneesDePage>> = {

  '/': {
    titre: 'Azoya Spa Vaux — institut de beauté et spa à Auxerre',
    description:
      'Institut de beauté et spa à quelques minutes d’Auxerre : soins du visage, massages, épilation, beauté des mains et des pieds. Réservation en ligne.',
  },
  '/services': {
    titre: 'Nos soins visage, corps et épilation — Azoya Spa Vaux',
    description:
      'Le catalogue complet de l’institut, famille par famille : spa et détente, visage et regard, corps et bien-être, épilation, silhouette, mains et pieds.',
  },
  '/offres-abonnement': {
    titre: 'Pass et abonnements bien-être — Azoya Spa Vaux, Auxerre',
    description:
      'Les formules de l’institut pour revenir régulièrement : pass, abonnements et avantages associés, avec la marche à suivre pour souscrire à Auxerre.',
  },
  '/reserver-en-ligne': {
    titre: 'Réserver un soin en ligne — Azoya Spa Vaux, Auxerre',
    description:
      'Prenez rendez-vous à l’institut en quelques minutes : choisissez votre soin, votre date et votre horaire, et recevez la confirmation immédiatement.',
  },
  '/offrir': {
    titre: 'Offrir une carte cadeau spa — Azoya Spa Vaux, Auxerre',
    description:
      'Offrez un soin ou un moment au spa : carte cadeau à commander en ligne, valable sur l’ensemble des prestations de l’institut, à Vaux près d’Auxerre.',
  },
  '/mentions-legales': {
    titre: 'Mentions légales et éditeur du site — Azoya Spa Vaux',
    description:
      'Éditeur du site, hébergement, propriété intellectuelle, données personnelles et transparence sur les visuels : les informations légales de l’institut.',
  },
  '/cgu': {
    titre: 'Conditions générales d’utilisation — Azoya Spa Vaux',
    description:
      'Les règles d’usage du site : accès aux services, réservation, cookies et traceurs déposés, droits des utilisateurs et responsabilités de l’éditeur.',
  },
}
